import "./ValueView.css"
import { useContext, createElement } from "react"

import { formatValue } from "web/services/format"
import { isAValue, isNotAValue } from "web/services/helpers"

import { LockIcon } from "../LockIcon/LockIcon"
import CalculatedValueIcon from "web/components/ValueView/CalculatedValueIcon"
import InfoIcon from "web/components/ValueView/InfoIcon"
import { LocalizationContext } from "web/contexts"

import URLViewer from "./viewer/URLViewer"
import CompanyViewer from "./viewer/CompanyViewer"
import PortfolioViewer from "./viewer/PortfolioViewer"
import UserViewer from "./viewer/UserViewer"
import RichTextViewer from "./viewer/RichTextViewer"
import ContactViewer from "./viewer/ContactViewer"

import MultiValueDisplay from "./MultiValueDisplay"
import SingleValueDisplay from "./SingleValueDisplay"

const viewers = [
  URLViewer,
  CompanyViewer,
  PortfolioViewer,
  UserViewer,
  RichTextViewer,
  ContactViewer,
]

function Viewer(
  fieldKey,
  value,
  inert,
  readOnly,
  preventClickHandler,
  showLinkIcon,
  truncateValue
) {
  const viewer = viewers.find((el) => el.isViewerFor(value))

  if (!viewer) {
    return formatValue(value)
  } else {
    return createElement(viewer, {
      fieldKey,
      value,
      inert,
      readOnly,
      preventClickHandler,
      showLinkIcon,
      truncateValue,
    })
  }
}

export default function ValueView({
  fieldKey = "",
  placeholder = null,
  value: display,
  has_more_info: hasMoreInfo = false,
  is_calculated: isCalculated = false,
  percentValue,
  inert = false,
  readOnly = false,
  fieldPresentation,
  showLock = false,
  preventClickHandler = false,
  showLinkIcon = false,
}) {
  const { viewCurrency } = useContext(LocalizationContext)
  const isList = Array.isArray(display)

  const displayValue =
    ["value", "value_percentage"].includes(fieldPresentation) ||
    !fieldPresentation
  const displayPercentSuffix =
    fieldPresentation === "value_percentage" && isAValue(percentValue)
  const displayOnlyPercentage =
    fieldPresentation === "percentage" && isAValue(percentValue)

  if (isNotAValue(display) || (!isList && isNotAValue(display.value))) {
    return (
      <div className="flex min-w-0 items-center">
        {placeholder}
        {showLock && (
          <span className="ml-auto">
            <LockIcon />
          </span>
        )}
      </div>
    )
  }

  const displayList = isList ? display : [display]
  return (
    <div className="flex min-w-0 items-center">
      {isList ? (
        <MultiValueDisplay
          displayList={displayList}
          fieldKey={fieldKey}
          inert={inert}
          readOnly={readOnly}
          preventClickHandler={preventClickHandler}
          showLinkIcon={showLinkIcon}
          displayValue={displayValue}
          Viewer={Viewer}
        />
      ) : (
        <SingleValueDisplay
          display={display}
          fieldKey={fieldKey}
          inert={inert}
          readOnly={readOnly}
          preventClickHandler={preventClickHandler}
          showLinkIcon={showLinkIcon}
          displayValue={displayValue}
          valueIsFX={display.kind === "Money" && display.unit !== viewCurrency}
          displayPercentSuffix={displayPercentSuffix}
          percentValue={percentValue}
          displayOnlyPercentage={displayOnlyPercentage}
          Viewer={Viewer}
        />
      )}
      {isCalculated && (
        <CalculatedValueIcon
          title="Calculated Value"
          className="ml-1 text-neutral-6"
        />
      )}
      {hasMoreInfo && <InfoIcon fieldKey={fieldKey} />}
      {showLock && (
        <span className="ml-auto">
          <LockIcon />
        </span>
      )}
    </div>
  )
}
